<template>
  <div class="search-associate">
    <ul class="search-associate-list">
      <li
        class="search-associate-item"
        v-for="item in associateList"
        :key="item"
      >
        <lr-link :to="getSearchUrl(item)" @click="handleClick(item)">{{
          item
        }}</lr-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { getSearchUrl } from '@/common/utils';

export default {
  props: {
    associateList: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    getSearchUrl,

    handleClick(keyword) {
      this.$emit('click', { keyword })
      this.$collect.homepageSearchClick({
        action: 'suggestions',
        keyword,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.search-associate {
  @include dropdown-style();
  width: 100%;

  &-item {
    padding: 0 15px;
    list-style: none;
    text-align: left;
    line-height: 40px;
    box-sizing: border-box;

    > a {
      display: block;
      color: #222226;
    }
  }
}
</style>
